// extracted by mini-css-extract-plugin
export default {"container":"style_container__dMBOQ","name":"style_name__nZbbP","volume":"style_volume__wq+1p","playing":"style_playing__MOl5m","forward":"style_forward__V7GCr"};